import * as React from 'react';
import { Separator, XStack, YStack } from 'smoothie';

export const EditableSelectableRow = ({
    rowContentComponent,
    isFirstRow,
    isSelected,
    isMultiSelect,
    onEdit,
}: {
    rowContentComponent: React.JSX.Element;
    isFirstRow: boolean;
    isSelected: boolean;
    isMultiSelect: boolean;
    onEdit?: () => void;
}) => {
    return (
        <YStack>
            {isFirstRow && isMultiSelect && <Separator />}
            <XStack
                paddingVertical={16}
                borderColor={
                    !isMultiSelect && isSelected ? '$green900' : 'transparent'
                }
                backgroundColor={
                    !isMultiSelect && isSelected ? '$green200' : 'transparent'
                }
            >
                {onEdit ? (
                    <XStack onPress={onEdit} style={{ cursor: 'pointer' }}>
                        {rowContentComponent}
                    </XStack>
                ) : (
                    rowContentComponent
                )}
            </XStack>
            {isMultiSelect && <Separator />}
        </YStack>
    );
};
